import { Box, Paper, Stack, Typography } from "@mui/material";
import "leaflet/dist/leaflet.css";
import Map from "../map/map.component";
import FieldNotes from "../fieldNotes/fieldNotes.component";

const FieldCard = ({
  fieldName,
  fieldCulture,
  noteDate,
  noteText,
  fieldPosition,
  polygonCoordinates,
  pmtilesUrl,
  subAreas,
  onClick,
}) => {
  return (
    <Paper
      sx={{
        p: 3,
        width: "100%",
        mt: 3,
        cursor: onClick ? "pointer" : "default",
        transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
        "&:hover": onClick
          ? {
              transform: "translateY(-2px)",
              boxShadow: 2,
            }
          : {},
      }}
      elevation={0}
      onClick={onClick}
    >
      <Stack direction="column" width="100%" height="100%">
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography sx={{ fontWeight: "bold", fontSize: "20px" }}>
            {fieldName}
          </Typography>
          <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>
            {`Coltura: ${fieldCulture}`}
          </Typography>
        </Box>

        <Box height="272px" py={2} borderRadius="2px" zIndex={0}>
          <Map
            fieldPosition={fieldPosition}
            fieldName={fieldName}
            polygonCoordinates={polygonCoordinates}
            pmtilesUrl={pmtilesUrl}
            subPolygonCoordinates={subAreas?.map((area) => area.polygon) || []}
            subAreas={subAreas}
          />
        </Box>

        <FieldNotes
          fieldName={fieldName}
          noteDate={noteDate}
          noteText={noteText}
        />
      </Stack>
    </Paper>
  );
};

export default FieldCard;
